import { AnimatePresence, motion } from "framer-motion";

interface Props {
  active: boolean;
}

const PARTICLES = Array.from({ length: 10 }, (_, i) => {
  const angle = (i * 36 + Math.random() * 18 - 9) * (Math.PI / 180);
  const dist = 70 + Math.random() * 50;
  return {
    key: i,
    tx: Math.cos(angle) * dist,
    ty: Math.sin(angle) * dist,
    emoji: i % 3 === 0 ? "✦" : i % 3 === 1 ? "★" : "✸",
    delay: i * 0.04,
    size: 14 + Math.random() * 12,
    rotate: Math.random() * 360,
  };
});

export function StarBurst({ active }: Props) {
  return (
    <div className="star-burst" aria-hidden="true">
      <AnimatePresence>
        {active &&
          PARTICLES.map((p) => (
            <motion.span
              key={p.key}
              className="star-particle"
              style={{ fontSize: p.size }}
              initial={{ x: 0, y: 0, scale: 0, opacity: 1, rotate: 0 }}
              animate={{
                x: p.tx,
                y: p.ty,
                scale: [0, 1.4, 0.8],
                opacity: [1, 1, 0],
                rotate: p.rotate,
              }}
              exit={{ opacity: 0 }}
              transition={{
                duration: 0.65,
                delay: p.delay,
                ease: "easeOut",
              }}
            >
              {p.emoji}
            </motion.span>
          ))}
      </AnimatePresence>
    </div>
  );
}
